import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useStyles } from './AnalyticsPage.styles';
import { ThemeProps } from '@styles/theme';
import { NeoAnalyticsOverview } from '../NeoAnalyticsOverview';

export const AnalyticsPage: React.FC = () => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    return (
        <div className={styles.pageShell}>
            <NeoAnalyticsOverview />
        </div>
    )
}
